import useTranslation from 'next-translate/useTranslation';

// AirHelp affiliate links (Post Affiliate Pro). Attribution is carried by
// a_aid=cphsecuritywait; a_bid only tells AirHelp's reports which creative
// was clicked.
const AIRHELP_URLS = {
    da: 'https://www.airhelp.dk/?utm_medium=affiliate&utm_source=pap&utm_campaign=aff-cphsecuritywait&utm_content=&a_aid=cphsecuritywait&a_bid=09dc7242',
    en: 'https://www.airhelp.com/en-int/?utm_medium=affiliate&utm_source=pap&utm_campaign=cphsecuritywait&partner=affiliate&a_aid=cphsecuritywait&a_bid=152a5842'
};

// text-[#fff] rather than text-white on purpose: text-white does not apply on
// these buttons (verified in the browser, computed colour came out gray-800 on
// the navy background, making the CTA text invisible). Arbitrary values are
// emitted reliably, which is why bg-[var(--primary)] on the same element works.
const AffiliateLink = ({ type, text, umamiId, className }) => {
    const { lang } = useTranslation();
    const url = AIRHELP_URLS[lang] || AIRHELP_URLS.en;

    if (type === 'button') {
        return (
            <a
                href={url}
                target="_blank"
                rel="sponsored noopener noreferrer"
                className={`inline-block rounded bg-[var(--primary)] px-8 py-3 text-sm font-medium text-[#fff] transition hover:rotate-2 hover:scale-110 focus:outline-none focus:ring active:bg-[var(--primary)] ${className}`}
                data-umami-event={`affiliate-click-${umamiId}`}
                data-umami-event-type="button"
            >
                {text}
            </a>
        );
    } else if (type === 'text') {
        return (
            <a
                href={url}
                target="_blank"
                rel="sponsored noopener noreferrer"
                className={className}
                data-umami-event={`affiliate-click-${umamiId}`}
                data-umami-event-type="text"
            >
                {text}
            </a>
        );
    }
};

export default AffiliateLink;
